import { DynamicFormV2Palette } from "@mui/material";

export type FormChipComponentTokenType = {
  neutral: {
    filled: {
      backgroundColor: string;
      textColor: string;
    };
    outlined: {
      backgroundColor: string;
      borderColor: string;
      textColor: string;
    };
  };
  danger: {
    filled: {
      backgroundColor: string;
      textColor: string;
    };
    outlined: {
      backgroundColor: string;
      borderColor: string;
      textColor: string;
    };
  };
  emphasis: {
    filled: {
      backgroundColor: string;
      textColor: string;
    };
    outlined: {
      backgroundColor: string;
      borderColor: string;
      textColor: string;
    };
  };
  focusOutlineColor: string;
};

export const assignChipComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    neutral: {
      filled: {
        backgroundColor: formsPalette.surface.quiet,
        textColor: formsPalette.text.brand,
      },
      outlined: {
        backgroundColor: formsPalette.surface.supershy,
        borderColor: isLightMode ? formsPalette.border.moderate : formsPalette.border.brand,
        textColor: isLightMode ? formsPalette.text.brand : formsPalette.text.intense,
      },
    },
    danger: {
      filled: {
        backgroundColor: formsPalette.surface.error,
        textColor: formsPalette.text.error,
      },
      outlined: {
        backgroundColor: formsPalette.surface.error,
        borderColor: formsPalette.border.error,
        textColor: isLightMode ? formsPalette.text.error : formsPalette.text.intense,
      },
    },
    emphasis: {
      filled: {
        backgroundColor: isLightMode ? formsPalette.surface.intense : formsPalette.surface.reverse,
        textColor: formsPalette.text.reverse,
      },
      outlined: {
        backgroundColor: isLightMode ? formsPalette.surface.supershy : formsPalette.surface.intense,
        borderColor: isLightMode ? formsPalette.text.brand : formsPalette.border.brand, // We make an exception here by using a text token for the border color
        textColor: isLightMode ? formsPalette.text.brand : formsPalette.text.intense,
      },
    },
    focusOutlineColor: formsPalette.border.quiet,
  } as FormChipComponentTokenType;
};
